import React, { useEffect, useState } from 'react';
import is from 'is_js';
import { useNavigate, Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Chart as ChartJS, registerables } from 'chart.js';
import { CloseButton } from 'components/common/Toast';
import SettingsToggle from 'components/settings-panel/SettingsToggle';
import SettingsPanel from 'components/settings-panel/SettingsPanel';
import { useAppContext } from 'providers/AppProvider';
import { TokenManager } from 'utils/tokenManager';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import { Loading } from 'components/common/Loading';
import useIdleTimer from 'hooks/useIdleTimer';
// import TokenDebugger from 'components/TokenDebugger'; // 토큰 디버거 활성화 시 해당 주석 해제
import { useRouteTokenGuard } from 'hooks/useRouteTokenGuard';
import useTokenManager from 'hooks/useTokenManager';
import paths from 'routes/paths';
import { useLocation } from 'react-router-dom';

ChartJS.register(...registerables);

const App = () => {
  const location = useLocation();
  useIdleTimer(2 * 60 * 60 * 1000);// 애플리케이션 전역에서 비활동 감지
  useRouteTokenGuard(); // 라우트 이동 시 토큰 상태 체크
  const tokenManagerState = useTokenManager(); // 스마트 하이브리드 토큰 관리

  const navigate = useNavigate();

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition, isLoading, userAuth, checkorg }
  } = useAppContext();

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  // 전역 라우트 변경 로깅 제거

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);


  // 인증 로직은 ProtectedRoute 컴포넌트에서 처리됨

  useEffect(() => {
    if (window.location.pathname === '/') {
      if (userAuth === 'SA') {
        // navigate('/dashboard/crm');
        navigate('/safedb/SA/adminSites');
      } else {
        navigate('/');
      }
    }
  }, [userAuth, navigate]);



  return (
    <>
      {isLoading && <Loading />}
      {/* <TokenDebugger tokenManagerState={tokenManagerState} /> */} {/* 토큰 디버거 활성화 시 해당 주석 해제 */}
      <Outlet />
      {/* 우측에 커스터마이즈 버튼 숨김처리 */}
      {/* <SettingsToggle /> */}
      <SettingsPanel />
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position="bottom-left"
      />
    </>
  );
};

export default App;
